/**
 * The entry values store lives in localStorage, so it can still hold answers from another entry: a form
 * left part way, or one filled in by another user on the same device. Those must never be saved with
 * this entry. Writing them fails row-level security (the user cannot see that entry), and merging by
 * input_id would hand this entry another entry's entry_value_id. Answers not yet tied to an entry
 * (entry_id "") are kept.
 */
export function onlyThisEntryValues<T extends { entry_id?: string | null }>(
    entryValues: readonly T[],
    entryId: string
): T[] {
    return entryValues.filter((value) => !value.entry_id || value.entry_id === entryId);
}
